import type { AppListItem } from '@/api/apps'
import { DEFAULT_APP_ICON } from '@/lib/appIcon'
import type { VersionStatus } from '@/types'
import type { WorkbenchAppCard, WorkbenchCardStatus } from './types'

const CARD_STATUS: Partial<Record<VersionStatus, WorkbenchCardStatus>> = {
  reviewing: 'in_review',
  scheduled: 'pending',
  released: 'published',
  developing: 'developing',
  rejected: 'rejected',
  delisted: 'delisted',
  disabled: 'disabled',
  archived: 'archived',
}

function formatUpdatedAt(iso?: string): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** API 列表项 → 工作台卡片展示模型 */
export function toWorkbenchAppCard(item: AppListItem): WorkbenchAppCard {
  const ownerName = item.owner_nickname ?? item.owner_username ?? '—'
  const owner_username = item.owner_username ?? '—'
  const status = item.status ? CARD_STATUS[item.status] : undefined

  return {
    id: item.id,
    name: item.name || item.id,
    icon: item.icon_url || DEFAULT_APP_ICON,
    isCollaborator: item.has_collaborators,
    versionLabel: item.version_code ? `v ${item.version_code}` : '—',
    version_id: item.version_id,
    ownerName,
    owner_username,
    isOwner: !item.has_collaborators,
    distribution: item.space_id ? 'space_private' : 'public',
    updated_at: formatUpdatedAt(item.updated_at),
    status: status ?? 'developing',
  }
}
